class Debug {
  constructor () {
    this.draw = false
  }
}

export default new Debug()
